import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import { FieldValue } from 'firebase/firestore';

/*import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, FieldValue } from 'firebase/firestore';
*/

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAArIG0jPkGbviUzMNMAF_oXZPFmZmRtRs",
  authDomain: "longoka-lft.firebaseapp.com",
  projectId: "longoka-lft",
  storageBucket: "longoka-lft.firebasestorage.app",
  messagingSenderId: "99347028337",
  appId: "1:99347028337:web:f47c244338727525ca7ed0",
  measurementId: "G-XWWBR8JG49"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

/*const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
*/
export const FieldValueRef = FieldValue;
export const auth = firebase.auth();
export const db = firebase.firestore();
export default firebase;